import { Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type Props = {
  pendingCount: number;
};

export const GlobalAlertBanner = ({ pendingCount }: Props) => {
  const { t } = useTranslation('rate-card-manager', { keyPrefix: 'shell' });
  const navigate = useNavigate();

  if (pendingCount === 0) return null;

  return (
    <Alert
      action={
        <Button color="inherit" onClick={() => navigate('/rate-cards/approvals')} size="small">
          {t('viewApprovals')}
        </Button>
      }
      severity="warning"
    >
      {t('pendingApprovals', { count: pendingCount })}
    </Alert>
  );
};
